// extracted by mini-css-extract-plugin
export var container = "_70-0";
export var containerTopRight = "_70-1";